import { useEffect, RefObject } from 'react'

type Props = {
  ref: RefObject<HTMLElement>
  isDisabled?: boolean
  topOffset?: number
  behavior?: ScrollBehavior
  timeoutMs?: number
}

export const useScrollToElementOnMount = (props: Props) => {
  const { isDisabled, ref, topOffset = 0, behavior = 'smooth', timeoutMs = 0 } = props

  useEffect(() => {
    let timeout: number | undefined

    if (!isDisabled) {
      timeout = window.setTimeout(() => {
        const element = ref.current
        const scrollElement = document.scrollingElement

        if (!element || !scrollElement) return

        const { top: elementRectTop } = element.getBoundingClientRect()
        const { scrollTop } = scrollElement
        const elementTop = scrollTop + elementRectTop - topOffset

        if (elementTop < scrollTop) {
          scrollElement.scroll({ top: elementTop, behavior })
        }
      }, timeoutMs)
    }

    return () => clearTimeout(timeout)
  }, [timeoutMs, isDisabled, ref, topOffset, behavior])
}
